export interface Station {
    stationId: string;
    code: number | string;
    description: string;
    lat: number;
    lng: number;
    address?: string;
    city?: string;
    province?: string;
    zip?: string;
    countryCode?: string;
    logoPicture?: string;
    stationPicture?: string;
    outsidePicture?: string;
    maxBikes?: number;
    openingTimes?: { [dayOfWeek: number]: (StationOpeningTime[] | null | undefined) };
}

export interface StationPublic {
    stationId: string;
    picture?: string;
    code: number | string;
    description: string;
    lat: number;
    lng: number;
    address?: string;
    city?: string;
    province?: string;
    zip?: string;
    countryCode?: string;
    bikesCount?: number;
    distance?: number;
    logoPicture?: string;
    stationPicture?: string;
    outsidePicture?: string;
    maxBikes?: number;
    openingTimes?: { [dayOfWeek: number]: (StationOpeningTime[] | null | undefined) };
    open?: boolean;
    nextClose?: Date;
    nextOpen?: Date;
    openTime?: { open: Date, close: Date };
    classOverride?: string;
    bonus?: number;
}

export interface StationOpeningTime {
    open: string;
    close: string;
}

export interface StationFilter {
    options: {
        city: any[]
        province: any[];
        zip: any[];
        countryCode: any[];
    },
    cache: {
        city: any[]
        province: any[];
        zip: any[];
        countryCode: any[];
    },
    values: {
        city?: string;
        province?: string;
        zip?: string;
        countryCode?: string;
    },
    applied: {
        city?: string;
        province?: string;
        zip?: string;
        countryCode?: string;
    }
}

export function getDefaultStation(): Station {
    return structuredClone({
        stationId: '',
        code: '',
        description: '',
        lat: 0,
        lng: 0,
    })
}